module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3uS1WX/cover.jpeg?1685327174456",
      "alt": "This image is the cover for the book Sword Emperor, Volume 28"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sword Emperor, Volume 28\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('strong', [_vm._v("There are no laws or regulations in the world where everyone respects only martial arts. ")])]), _c('p'), _c('p', [_vm._v("Everything can only be decided by one's power.   It was said that a senior cultivator was able to move mountains and reclaim the land as well as handle the sun and the moon.   The orphan Sun Bing from earth came to this new world due to a mysterious sword box. Ten years, one hundred and twenty times of humiliation did not defeat him but only made him more tough-minded. After a decade of grinding sword, Sun Bing began to shine. How far can this boy finally go? ")]), _c('p'), _c('p', [_c('strong', [_vm._v(" ☆About the Author☆ ")])]), _c('p', [_vm._v("Qing Shan Zhang Jian, a new web novelist, has his fiction debut Sword Emperor which is still ongoing. As a novelist who has been formally writing for less than one year, Qing Shan Zhang Jian keeps a humble learning attitude. His fans are also looking forward to his follow-up work.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Qing Shanzhangjian, Babel Novel\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Funstory\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0